import { Link, useNavigate, useParams } from "react-router-dom";
import { Avatar } from "../components/Avatar";
import { Levels } from "../components/Pips";
import { ProgressCharts } from "../components/ProgressCharts";
import { api } from "../lib/api";
import { useAuth } from "../lib/auth";
import { useLoad } from "../lib/hooks";
import type { Profile as ProfileData } from "../lib/types";

/** A player's page: theirs at /u/:username, yours at /stats. */
export function Profile({ self }: { self?: boolean }) {
  const { user } = useAuth();
  const params = useParams();
  const nav = useNavigate();
  const username = self ? user!.username : params.username!;
  const { data, error } = useLoad(() => api<ProfileData>(`/users/${username}`), [username]);
  if (error) return <main className="page"><div className="error">{error}</div></main>;
  if (!data) return <main className="page"><div className="empty">Loading…</div></main>;
  const u = data.user, t = data.totals, rec = data.record;
  return <main className="page">
    {!self && <button className="btn quiet" onClick={() => nav(-1)}>‹ Back</button>}
    <div style={{ display: "flex", gap: 14, alignItems: "center", margin: "8px 0 16px" }}>
      <Avatar user={u} size="lg" />
      <div><h1 style={{ margin: 0 }}>{self ? "Stats" : u.displayName}</h1>
        <div className="mute small">{self ? u.displayName + ", " : ""}joined {new Date(u.joined).toLocaleDateString([], { month: "short", year: "numeric" })}</div></div>
    </div>
    <div className="grid2">
      <div className="card"><div className="small mute">This week</div><div className="big-num">{data.week.value}</div><div className="small mute">{data.week.rank ? `#${data.week.rank} of ${data.week.of}` : "unranked"}</div></div>
      <div className="card"><div className="small mute">Streak</div><div className="big-num">{data.streak.current}d</div><div className="small mute">longest {data.streak.longest}d</div></div>
      <div className="card"><div className="small mute">All time</div><div className="big-num">{t.points}</div><div className="small mute">{t.problems} problems, {t.problems ? Math.round((100 * t.correct) / t.problems) : 0}% correct</div></div>
      <div className="card"><div className="small mute">{data.vsMe ? "You vs them" : "Duels"}</div>
        <div className="big-num">{data.vsMe ? `${data.vsMe.wins}–${data.vsMe.losses}` : `${rec.wins}–${rec.losses}`}</div>
        <div className="small mute">{data.vsMe ? "your wins–losses" : "wins–losses"}{(data.vsMe ?? rec).ties ? `, ${(data.vsMe ?? rec).ties} tied` : ""}</div></div>
    </div>
    {!self && <Link className="btn ink" style={{ marginTop: 12 }} to="/duels" state={{ opponent: u.username }}>Challenge {u.displayName}</Link>}
    <h2>Levels</h2>
    <div className="card"><Levels ratings={data.ratings} /></div>
    <h2>Progress</h2>
    <ProgressCharts username={u.username} isMe={u.isMe} defaultCompare={self ? "" : user!.username} />
    {data.dailies.length > 0 && <><h2>Recent daily challenges</h2>
      <div className="card"><table><thead><tr><th>Date</th><th>Score</th><th>Correct</th><th>Time</th></tr></thead>
        <tbody>{data.dailies.map((d) => <tr key={d.date}><td>{d.date}</td><td>{d.score}</td><td>{d.correct}/10</td><td>{Math.round(d.secs)}s</td></tr>)}</tbody></table></div></>}
  </main>;
}
